import React, { Component } from "react";
import ResourceMap from "./ResourceMap";
import ResourceCard from "./ResourceCard";
import Loader from "./Loader";
import axios from "axios";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import FormControl from "react-bootstrap/FormControl";
import ReactToPrint from "react-to-print";
import "react-widgets/dist/css/react-widgets.css";
import { Popover, OverlayTrigger, InputGroup, Row, Col } from "react-bootstrap";
import { FaSearch } from "react-icons/fa"; // FontAwesome icon
import { translate } from "react-switch-lang";
import TranslateRegionCard from "./Filter/RegionCard";
import TranslateTargetCard from "./Filter/TargetCard";
import TranslateCategoryCard from "./Filter/CategoryCard";
import TranslateSubCategoryCard from "./Filter/SubCategoryCard";

// Resource Map tab: fetches location rows from the API, runs region / category / subcategory / target / text filters,
// keeps map center+zoom in sync via calculateMidpoint, and renders ResourceMap + ResourceCard.
// Props: both = split desktop layout; map = list vs map on mobile; navExpanded / clickNav tie into App’s top navbar.

// Category / subcategory / region / target UIs live under ./Filter/*; multiselect “value” props mirror what the dropdown shows for clear/reset.
class FilterForm extends Component {
  constructor(props) {
    super(props);
    this.closePopover = this.closePopover.bind(this);
    this.state = {
      popoverOpen: false,
      showWelcomeModal: false, // Will be set to true after data loads
      searchValue: "", //search value for searching names
      locations: [], //original locations
      filteredLocations: [], // filtered locations (changes when click filter)
      regions: [], // all the different region
      regionValue: [],
      categoryValue: [], //to put on the ui for multiselect
      subCatValue: [], //to put on the ui for multiselect
      targetValue: [], //to put on the ui for multiselect
      subCatData: [], //to show only the sub category when cat is clicked
      targets: [],
      subCatOriginal: [], //to store the original for subcat
      currentRegion: "all", //what the filter currently click
      currentCategory: "all", //what the filter currently click
      currentTarget: "all", //what the filter currently click
      loading: true, //whether data is loading to show loading screen
      currentSubCategory: ["all"], //what the filter currently click
      lat: 22.29442, //default lat
      lng: 114.17274, //default long
      zoom: 10, //default zoom
    };
  }
  clearFilter = () => {
    //clears the filter
    this.setState({
      currentRegion: "all",
      currentCategory: "all",
      currentTarget: "all",
	  currentSubCategory: ["all"],
      regionValue: [],
      categoryValue: [],
      subCatValue: [],
      targetValue: [],
      subCatData: this.state.subCatOriginal, // Reset to original subcategory data
      lat: 22.29442,
      lng: 114.17274,
      zoom: 10,
      filteredLocations: this.state.locations,
    });
  };

  calculateMidpoint = (locations) => {
    //calculate midpoint based on filtered locations
    if (locations.length === 0) {
      // if empty no location then default
      const avgLat = 22.29442;
      const avgLong = 114.17274;
      const zoom = 10;

      return { avgLat, avgLong, zoom };
    } else if (locations.length === 1) {
      // Single location - zoom in close but not too close
      const location = locations[0];
      const avgLat = location["Latitude"];
      const avgLong = location["Longitude"];
      const zoom = 14; // Good zoom for single location
      
      if (!this.props.both) {
        // Adjust for mobile filter
        return { avgLat: avgLat - 0.01, avgLong, zoom };
      }
      return { avgLat, avgLong, zoom };
    } else {
      //find the four points between all locations
      var minLat = locations[0]["Latitude"];
      var maxLat = locations[0]["Latitude"];
      var minLong = locations[0]["Longitude"];
      var maxLong = locations[0]["Longitude"];
      
      locations.forEach((location) => {
        if (location["Latitude"] > maxLat) {
          maxLat = location["Latitude"];
        }
        if (location["Latitude"] < minLat) {
          minLat = location["Latitude"];
        }
        if (location["Longitude"] > maxLong) {
          maxLong = location["Longitude"];
        }
        if (location["Longitude"] < minLong) {
          minLong = location["Longitude"];
        }
      });
      
      // Add padding around the bounds to ensure all markers are visible
      const padding = 0.002; // Reduced padding for tighter zoom
      minLat = minLat - padding;
      maxLat = maxLat + padding;
      minLong = minLong - padding;
      maxLong = maxLong + padding;
      
      //find avg points
      var avgLat = (minLat + maxLat) / 2;
      var avgLong = (minLong + maxLong) / 2;
      const diffLat = maxLat - minLat;
      const diffLong = maxLong - minLong;
      
      // Calculate zoom based on the spread of locations
      // Higher zoom = more zoomed in, lower zoom = more zoomed out
      let zoom = 12; // Default zoom
      const maxDiff = Math.max(diffLat, diffLong);
      
      // Dynamic zoom calculation based on spread
      if (maxDiff >= 0.1) {
        zoom = 12; // Very wide spread - zoom out to see all
      } else if (maxDiff >= 0.05) {
        zoom = 13; // Wide spread
      } else if (maxDiff >= 0.03) {
        zoom = 13.5; // Medium spread
      } else if (maxDiff >= 0.01) {
        zoom = 13.8; // Close spread - zoom in more
      } else if (maxDiff >= 0.005) {
        zoom = 14; // Very close spread - zoom in even more
      } else {
        zoom = 15; // Extremely close spread - maximum zoom
      }
      
      // Adjust for mobile vs desktop
      if (!this.props.both) {
        // Mobile adjustments
        if (diffLat >= 0.05) {
          avgLat = avgLat - 0.06;
        } else if (diffLat >= 0.03) {
          avgLat = avgLat - 0.03;
        } else if (diffLat >= 0.01) {
          avgLat = avgLat - 0.015;
        } else if (diffLat >= 0.005) {
          avgLat = avgLat - 0.01;
        } else {
          avgLat = avgLat - 0.0075;
        }
      }
      
      console.log(`Auto-zoom: ${locations.length} locations, zoom: ${zoom}, center: [${avgLat}, ${avgLong}]`);
      return { avgLat, avgLong, zoom };
    }
  };

  filterLocations = () => {
    // main function for filtering locations
    const { t } = this.props;
    let filteredLocations = this.state.locations;
    let cat = this.state.currentCategory;
    let region = this.state.currentRegion;
    let subCatData = this.state.subCatData;
    let subCatOriginal = this.state.subCatOriginal;
    
    let subCat = this.state.currentSubCategory.map(function (item) {
      const result = item;
      return result;
    });
    
    let tar = this.state.currentTarget;
    let searchValue = this.state.searchValue;
    // Target filter: each selected target name must exist as a key on the row (API exposes booleans per recipient type).
    function isTarget(location) {
      let isTar = false;
      tar.forEach((d) => {
        if (d in location) {
          isTar = true;
        } else {
        }
      });
      return isTar;
    }

    if (region !== "all" && region.length > 0) {
      //filter based on region
      filteredLocations = filteredLocations.filter((d, index) => {
        // Always use the raw "District" field for filtering to avoid language mismatch.
        const locationRegion = d["District"];

        // If the location has no region data, exclude it.
        if (!locationRegion) {
          return false;
        }

        // Check if locationRegion is a string before calling toLowerCase
        if (typeof locationRegion !== 'string') {
          console.error(`ERROR: Location ${index} District is not a string:`, typeof locationRegion, locationRegion);
          return false;
        }

        try {
          // Normalize both the location's region and the selected regions for a case-insensitive comparison.
          const normalizedLocationRegion = locationRegion.toLowerCase().trim();
          const normalizedSelectedRegions = region.map((r) => {
            if (typeof r !== 'string') {
              console.error(`ERROR: Region filter value is not a string:`, typeof r, r);
              return '';
            }
            return r.toLowerCase().trim();
          });

          const shouldInclude =
            normalizedSelectedRegions.includes(normalizedLocationRegion);

          return shouldInclude;
        } catch (error) {
          console.error(`ERROR in toLowerCase for location ${index}:`, error, locationRegion);
          return false;
        }
      });
      let { avgLat, avgLong, zoom } = this.calculateMidpoint(filteredLocations);
      this.setState({
        zoom: zoom,
        lat: avgLat,
        lng: avgLong,
      });
    } else {
      //change back to default if all

      this.setState({
        zoom: 10.5,
        lat: 22.29442,
        lng: 114.17274,
      });
    }
    if (cat !== "all" && cat.length > 0) {
      //filter based on category
      filteredLocations = filteredLocations.filter((d) =>
        cat.includes(d[t("categories.Title")])
      );
      subCatData = subCatOriginal.filter((d) =>
        cat.includes(d[t("categories.Title")])
      );
      let { avgLat, avgLong, zoom } = this.calculateMidpoint(filteredLocations);
      this.setState({
        zoom: zoom,
        lat: avgLat,
        lng: avgLong,
      });
    } else {
      //change the subcat back to original if category is all
      subCatData = subCatOriginal;
    }
    if (subCat[0] !== 'all' && subCat.length > 0) {
      //fitler for subcat
      filteredLocations = filteredLocations.filter((d) => {
        const locationSubCat = d[t("subCategories.Title2")];
        const shouldInclude = subCat.includes(locationSubCat);
        return shouldInclude;
      });
      let { avgLat, avgLong, zoom } = this.calculateMidpoint(filteredLocations);
      this.setState({
        zoom: zoom,
        lat: avgLat,
        lng: avgLong,
      });
    }
    if (tar !== "all" && tar.length > 0) {
      //fitler for target
      filteredLocations = filteredLocations.filter(isTarget);
      let { avgLat, avgLong, zoom } = this.calculateMidpoint(filteredLocations);
      this.setState({
        zoom: zoom,
        lat: avgLat,
        lng: avgLong,
      });
    }
    if (searchValue !== "") {
      //filter for search values
      filteredLocations = filteredLocations.filter((d, index) => {
        try {
          // Check each field before calling toLowerCase
          const nameField = d[t("names.Title")];
          const natureField = d[t("columns.Nature")];
          const targetField = d[t("columns.Target")];
          
          // Check if fields are strings before calling toLowerCase
          const nameMatch = nameField && typeof nameField === 'string' ? 
            nameField.toLowerCase().includes(searchValue.toLowerCase()) : false;
          const natureMatch = natureField && typeof natureField === 'string' ? 
            natureField.toLowerCase().includes(searchValue.toLowerCase()) : false;
          const targetMatch = targetField && typeof targetField === 'string' ? 
            targetField.toLowerCase().includes(searchValue.toLowerCase()) : false;
          
          const result = nameMatch || natureMatch || targetMatch;
          return result;
        } catch (error) {
          console.error(`ERROR in search filter for location ${index}:`, error, d);
          return false;
        }
      });
    }
    //set state so will render and filter
    this.setState({
      filteredLocations: filteredLocations,
      subCatData: subCatData,
    });
  };

  async componentDidUpdate(prevProps) {
    //parentnavExpanded so we can do interaction when click filter at the top bar (apps.js) it will close the filter at the bottom bar
    const parentNavExpanded = this.props.navExpanded;
    //pass lang so can clear filter when language change
    const lang = this.props.lang;
    if (prevProps.navExpanded !== parentNavExpanded) {
      this.setNavExpanded(false);
      this.closePopover();
    }
    //so when language is changed
    if (prevProps.lang !== lang) {
      this.clearFilter();
      this.openPopover();
    }
  }

  async componentDidMount() {
    window.gtag("event", "page_view", {
      page_path: "/resourcemap",
    });
    // Feathers REST API (hosted on Vercel) — resources + subcats drive filters and table/map.
    const res = await axios.get(
      "https://resource-project-backend.vercel.app/api/resources",
      {
        params: {
          $limit: 500,
        },
      }
    );

    const res2 = await axios.get(
      "https://resource-project-backend.vercel.app/api/subcats",
      {
        params: {
          $limit: 500,
        },
      }
    );

    const subCatData = Array.isArray(res2.data.data) ? res2.data.data : 
                      Array.isArray(res2.data) ? res2.data : []; // Ensure it's always an array
    const locations = res.data;

    // Check for critical data issues
    console.log("Loaded locations data - count:", locations.length);
    
    // Check for problematic data in the first few locations
    locations.slice(0, 3).forEach((location, index) => {
      if (location.Category === undefined || location.Category === null) {
        console.error(`ERROR: Location ${index} has undefined/null Category:`, location);
      }
      if (location.District === undefined || location.District === null) {
        console.error(`ERROR: Location ${index} has undefined/null District:`, location);
      }
      if (typeof location.District !== 'string' && location.District !== undefined) {
        console.error(`ERROR: Location ${index} District is not a string:`, typeof location.District, location.District);
      }
    });

    const z = require("zebras");
    const regions = z.unique(z.getCol(["District"], locations));
    const categories = z.unique(z.getCol(["Category"], locations));
    this.setState({
      open: false,
      regionOpen: false,
      targetOpen: false,
      targetSubCategoryOpen: false,
      navExpanded: true,
      loading: false,
      locations: locations,
      filteredLocations: locations,
      regions: regions,
      categories: categories,
      subCatData: subCatData,
      subCatOriginal: subCatData,
      show: false,
      showWelcomeModal: true, // Show welcome modal after data loads
      popoverOpen: false, // Disable the default popover when welcome modal is shown
    });
  }

  //handle search. Some has things like categoryvalue so to set up what is shown in multiselect presentation layer

  handleOrgSearch = (e) => {
    this.setState({ searchValue: e.target.value }, () => {
      this.filterLocations();
    });
  };

  handleRegionCardChange = (region) => {
    this.setState(
      {
        currentRegion: region,
        regionValue: region,
      },
      () => {
        this.filterLocations();
        this.setRegionOpen(false); // Close the dropdown
      }
    );
  };

  handleCategoryCardChange = (cat) => {
    const nextState =
      cat === "all"
        ? {
            currentCategory: "all",
            categoryValue: [],
            currentSubCategory: ["all"],
            subCatValue: [],
          }
        : {
            currentCategory: cat,
            categoryValue: cat,
            currentSubCategory: ["all"],
            subCatValue: [],
          };

    this.setState(nextState, () => {
      this.filterLocations();
      this.setOpen();
    });
  };

  handleSubCategoryCardChange = (subCat) => {
    this.setState({ currentSubCategory: subCat }, () => {
      this.filterLocations();
    });
    this.setState({ subCatValue: subCat });
    // Note: SubCategoryCard manages its own open state, so we don't need to close it here
  };

  handleTargetCardChange = (tar) => {
    this.setState({ targetValue: tar }, () => {
      this.filterLocations();
    });
    this.setState({ currentTarget: tar });
    this.setTargetOpen(false); // Close the dropdown
  };

  myCallback = (dataFromChild) => {
    this.setState({ lat: dataFromChild.lat, lng: dataFromChild.lng });
  };

  //to set the fitler expand or not for mobile
  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
    this.closePopover();
  };

  doNothing = () => {};

  //setOpen is for turning the category dropdown off
  setOpen = () => {
    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  };

  setRegionOpen = (isOpen) => {
    this.setState({
      regionOpen: isOpen,
    });
  };
  setTargetOpen = (isOpen) => {
    this.setState({
      targetOpen: isOpen,
    });
  };

  //close the filter
  closeNav = () => {
    this.setState({ navExpanded: false });
    this.closePopover();
  };
  closePopover() {
    this.setState({
      popoverOpen: false,
    });
  }

  openPopover() {
    this.setState({
      popoverOpen: true,
    });
  }

  // Welcome modal handlers
  handleWelcomeModalOkay = () => {
    // Apply the current filter settings and close the modal
    this.filterLocations();
    this.closeWelcomeModal();
  };

  closeWelcomeModal = () => {
    this.setState({
      showWelcomeModal: false,
      popoverOpen: true, // Re-enable popover after welcome modal closes
    });
  };

  // Render method to create the filter bar component
  renderFilterBar = (options = {}) => {
    const { showPrintButton = false } = options;
    const { t } = this.props;
    const both = this.props.both;
    const popoverTop = (
      <Popover
        id="popover-positioned-top"
        title="Popover top"
        bsClass="popover-dark"
        className="popover-dark"
      >
        <Popover.Content>
          <div style={{ width: "90%", padding: ".5em" }}>{t("Popover")}</div>
          <div
            style={{ width: "10%", marginLeft: "5px" }}
            onClick={this.closePopover}
            class="closingX"
          >
            ✕
          </div>
        </Popover.Content>
      </Popover>
    );

    return (
      <div className="filter-bar-container">
        {/* Filter bar moved to top of results area */}
        <Navbar
          onToggle={this.setNavExpanded}
          expanded={this.state.navExpanded}
          defaultExpanded
          bg="light"
          expand="md"
          className="custom-navbar filter-top-navbar"
        >
          {/* Filter header with search results count and clear button */}
          <div className="filter-header">
            <div className="filter-title">
              {t("links.Filters")}
              <span className="search-results">
                {"(" + this.state.filteredLocations.length + t("links.searchResults")}
              </span>
            </div>
            <button 
              className="clearFilters" 
              onClick={this.clearFilter}
            >
              {t("links.ClearFilters")}
            </button>
          </div>
    
          {/* Search input bar */}
          <div className="filter-search-bar d-flex align-items-center">
            <InputGroup className="search-input">
              <FormControl
                placeholder="搜尋所需服務"
                aria-label="Search"
                value={this.state.searchValue}
                onChange={this.handleOrgSearch}
              />
              <InputGroup.Text>
                <FaSearch />
              </InputGroup.Text>
            </InputGroup>
            {showPrintButton && (
              <div className="ms-2">
                <ReactToPrint
                  pageStyle="@page { size: auto; margin: 10mm; } @media print { .wideDiv { grid-template-columns: 1fr !important;} .resourceMap{ width:100vw !important; height:40vh !important; }.resourceTable { padding: 50px !important; width:100vw !important; overflow-y:visible !important;} }"
                  trigger={() => (
                    <button 
                      className="btn btn-secondary d-flex align-items-center justify-content-center print-only-button"
                      style={{ marginLeft: '10px' }}
                    >
                      <img
                        src="./print.png"
                        width="20px"
                        height="20px"
                        alt="Print"
                      />
                    </button>
                  )}
                  content={() => this.componentRef}
                />
              </div>
            )}
          </div>
    
          {/* Filter controls */}
          <Navbar.Collapse id="basic-navbar-nav">
          <Row className="filter-controls-horizontal g-2">
            <Col md={6} sm={6}>
              <TranslateRegionCard
                regionValue={this.state.regionValue}
                onCardChange={this.handleRegionCardChange}
                regions={this.state.regions}
                currentRegion={this.state.currentRegion}
                regionOpen={this.state.regionOpen}
                setRegionOpen={this.setRegionOpen}
                dropdownDirection="down"
              />
            </Col>
            <Col md={6} sm={6}>
              <TranslateCategoryCard 
                categoryValue={this.state.categoryValue}
                onCardChange={this.handleCategoryCardChange}
                categories={this.state.categories}
                currentCategory={this.state.currentCategory}
                open={this.state.open}
                setOpen={this.setOpen}
                dropdownDirection="down"
              />
            </Col>
            <Col md={6} sm={6}>
              <TranslateSubCategoryCard
                subCatValue={this.state.subCatValue}
                onCardChange={this.handleSubCategoryCardChange}
                subCatData={this.state.subCatData}
                dropdownDirection="down"
              />
            </Col>
            <Col md={6} sm={6}>
              <TranslateTargetCard
                targetValue={this.state.targetValue}
                onCardChange={this.handleTargetCardChange}
                currentTarget={this.state.currentTarget}
                setTargetOpen={this.setTargetOpen}
                dropdownDirection="down"
              />
            </Col>
          </Row>
          </Navbar.Collapse>


          {/* Action buttons for non-both layout */}
          {!both && (
            <div className="filter-actions">
              <OverlayTrigger
                defaultShow={true}
                show={this.state.popoverOpen}
                onClick={this.closePopover}
                placement="top"
                overlay={popoverTop}
              >
                <div
                  className={this.props.map ? "cardToggle" : "cardToggle on"}
                  onClick={() =>
                    this.props.clickNav(true, false, false, false, false, false)
                  }
                >
                  <img
                    id="mapPopover"
                    src="./list.png"
                    width="17px"
                    height="17px"
                    alt="List"
                  />
                  {t("links.List")}
                </div>
              </OverlayTrigger>
              <div
                className={this.props.map ? "mapToggle on" : "mapToggle"}
                onClick={() =>
                  this.props.clickNav(true, true, false, false, false, false)
                }
              >
                <img
                  src="./map.png"
                  width="17px"
                  height="17px"
                  alt="Map"
                />
                {t("links.MapToggle")}
              </div>
              {!this.props.map && (
                <ReactToPrint
                  pageStyle="@page { size: auto; margin: 10mm; } @media print { .resourceMap{  }.resourceTable { padding: 10px !important; width:100% !important; overflow-y:visible !important;} }"
                  trigger={() => (
                    <div className="printToggle">
                      <img src="./print.svg" className="print-icon" alt="Print" />
                      {t("links.Print")}
                    </div>
                  )}
                  content={() => this.componentRef}
                />
              )}
            </div>
          )}
        </Navbar>
      </div>
    );
    };
    

  render() {
    const map = this.props.map;
    const both = this.props.both;
    const { t } = this.props;
    // 检测是否为移动竖屏设备（可以根据实际需求调整判断条件）
    const isMobilePortrait = window.innerWidth < 768 && window.innerHeight > window.innerWidth;
    const lowerBarClass = this.state.navExpanded ? "lower-bar" : "lower-bar-close";
    const togglesClass = this.state.navExpanded ? "toggles-margin-top" : "toggles";

    // 底部可折叠Filter Bar（移动竖屏专用）
    const renderMobileBottomFilter = () => (
      <Navbar
        onToggle={this.setNavExpanded}
        expanded={this.state.navExpanded}
        defaultExpanded
        bg="light"
        expand="md"
        fixed="bottom"
        className="custom-navbar mobile-bottom-filter"
      >
        {this.state.navExpanded ? (
          both ? (
            <>
              <div className="top-bar">
                {t("links.Filters")}
                <div className="search-results">
                  {" (" + this.state.filteredLocations.length + t("links.searchResults") + ")"}
                </div>
                <div className="clearFilters" onClick={this.clearFilter}>
                  {t("links.ClearFilters")}
                </div>
              </div>
              <div className="filter-bar mt-2 mb-2">
                <InputGroup className="search-input">
                  <FormControl
                    placeholder="搜尋所需服務"
                    aria-label="Search"
                    value={this.state.searchValue}
                    onChange={this.handleOrgSearch}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </div>
            </>
          ) : (
            <div style={{ width: "100%", float: "left" }}>
              <div style={{ float: "left" }}>
                {t("links.Filters")}
                {"  (" + this.state.filteredLocations.length + t("links.searchResults") + ")"}
              </div>
              <div className="clearFilters" onClick={this.clearFilter}>
                {t("links.ClearFilters")}
              </div>
            </div>
          )
        ) : (
          <div className="filter-collapsed">
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="filter-toggle"
            >
              <div className="filter-words"> {t("links.Filters")}</div>
              <img
                src="./filter.png"
                style={{ marginLeft: "10px" }}
                width="15px"
                height="15px"
                alt="Filter"
              />
            </Navbar.Toggle>
            <div className="hiddenWhenNotCollapse">
              {"(" + this.state.filteredLocations.length + t("links.searchResults") + ")"}
            </div>
          </div>
        )}

        <div className={lowerBarClass}>
          <Navbar.Collapse id="basic-navbar-nav">
            <TranslateRegionCard
              regionValue={this.state.regionValue}
              onCardChange={this.handleRegionCardChange}
              regions={this.state.regions}
              currentRegion={this.state.currentRegion}
              regionOpen={this.state.regionOpen}
              setRegionOpen={this.setRegionOpen}
            />
            <TranslateCategoryCard
              categoryValue={this.state.categoryValue}
              onCardChange={this.handleCategoryCardChange}
              categories={this.state.categories}
              currentCategory={this.state.currentCategory}
              open={this.state.open}
              setOpen={this.setOpen}
            />
            <TranslateSubCategoryCard
              subCatValue={this.state.subCatValue}
              onCardChange={this.handleSubCategoryCardChange}
              subCatData={this.state.subCatData}
            />
            <TranslateTargetCard
              targetValue={this.state.targetValue}
              onCardChange={this.handleTargetCardChange}
              currentTarget={this.state.currentTarget}
              setTargetOpen={this.setTargetOpen}
            />
          </Navbar.Collapse>

          {both ? (
            <div>
              <Nav.Item>
                <ReactToPrint
                  pageStyle="@page { size: auto; margin: 10mm; } @media print { .wideDiv { grid-template-columns: 1fr !important;} .resourceMap{ width:100vw !important; height:40vh !important; }.resourceTable { padding: 50px !important; width:100vw !important; overflow-y:visible !important;} }"
                  trigger={() => (
                    <button
                      type="button"
                      className="nav-link btn btn-link border-0 bg-transparent p-1"
                      aria-label={t("links.Print")}
                    >
                      <img
                        src="./print.png"
                        width="25px"
                        height="25px"
                        alt="Print"
                      />
                    </button>
                  )}
                  content={() => this.componentRef}
                />
              </Nav.Item>
            </div>
          ) : (
            <div className={togglesClass}>
              <OverlayTrigger
                defaultShow={true}
                show={this.state.popoverOpen}
                onClick={this.closePopover}
                placement="top"
                overlay={this.renderPopoverTop()}
              >
                <div
                  className={map ? "cardToggle" : "cardToggle on"}
                  onClick={() =>
                    this.props.clickNav(true, false, false, false, false, false)
                  }
                >
                  <img
                    id="mapPopover"
                    src="./list.png"
                    style={{ marginLeft: "10px" }}
                    width="17px"
                    height="17px"
                    alt="List"
                  />
                  {t("links.List")}
                </div>
              </OverlayTrigger>
              <div
                className={map ? "mapToggle on" : "mapToggle"}
                onClick={() =>
                  this.props.clickNav(true, true, false, false, false, false)
                }
              >
                <img
                  src="./map.png"
                  style={{ marginLeft: "10px" }}
                  width="17px"
                  height="17px"
                  alt="Map"
                />
                {t("links.MapToggle")}
              </div>
              {!this.props.map && (
                <ReactToPrint
                  pageStyle="@page { size: auto; margin: 10mm; } @media print { .resourceMap{  }.resourceTable { padding: 10px !important; width:100% !important; overflow-y:visible !important;} }"
                  trigger={() => (
                    <div className="printToggle">
                      <img src="./print.svg" className="print-icon" alt="Print" />
                      {t("links.Print")}
                    </div>
                  )}
                  content={() => this.componentRef}
                />
              )}
              {this.state.navExpanded && (
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  style={{ float: "right" }}
                  onClick={() => this.setNavExpanded(false)}
                >
                  {t("links.Done")}
                </Navbar.Toggle>
              )}
            </div>
          )}
        </div>
      </Navbar>
    );

    // 提取PopoverTop为单独方法便于复用
    this.renderPopoverTop = () => (
      <Popover
        id="popover-positioned-top"
        title="Popover top"
        bsClass="popover-dark"
        className="popover-dark"
      >
        <Popover.Content>
          <div style={{ width: "90%", padding: ".5em" }}>{t("Popover")}</div>
          <div
            style={{ width: "10%", marginLeft: "5px" }}
            onClick={this.closePopover}
            className="closingX"
          >
            ✕
          </div>
        </Popover.Content>
      </Popover>
    );

    return (
      <div>
        {this.state.loading ? (
          <Loader />
        ) : (
          <div>
            {/* Welcome Modal */}
            {!this.state.loading && this.state.showWelcomeModal && (
              <div className="welcome-modal-overlay">
                {/* 保持欢迎模态框代码不变 */}
                <div className="welcome-modal">
                  <div className="welcome-modal-content">
                    <h2 className="welcome-modal-title1">
                      {t("welcomeModal.title1")}
                    </h2>
                    <h2 className="welcome-modal-title2">
                      {t("welcomeModal.title2")}
                    </h2>
                    <p>{t("welcomeModal.description") || "請選擇篩選條件："}</p>
                    <div className="welcome-filters">
                      <TranslateRegionCard
                        regionValue={this.state.regionValue}
                        onCardChange={this.handleRegionCardChange}
                        regions={this.state.regions}
                        currentRegion={this.state.currentRegion}
                        regionOpen={this.state.regionOpen}
                        setRegionOpen={this.setRegionOpen}
                      />
                      <TranslateCategoryCard
                        categoryValue={this.state.categoryValue}
                        onCardChange={this.handleCategoryCardChange}
                        categories={this.state.categories}
                        currentCategory={this.state.currentCategory}
                        open={this.state.open}
                        setOpen={this.setOpen}
                      />
                      <TranslateSubCategoryCard
                        subCatValue={this.state.subCatValue}
                        onCardChange={this.handleSubCategoryCardChange}
                        subCatData={this.state.subCatData}
                      />
                      <TranslateTargetCard
                        targetValue={this.state.targetValue}
                        onCardChange={this.handleTargetCardChange}
                        currentTarget={this.state.currentTarget}
                        setTargetOpen={this.setTargetOpen}
                      />
                    </div>
                    <div className="welcome-modal-actions">
                      <button
                        className="welcome-modal-btn"
                        onClick={this.handleWelcomeModalOkay}
                      >
                        {t("welcomeModal.okay") || "設定"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 主布局 */}
            {both ? (
              <div className="wideDiv" ref={(el) => (this.componentRef = el)}>
                <ResourceMap
                  key={`map-${this.state.lat}-${this.state.lng}-${this.state.zoom}`}
                  closeFilter={this.doNothing}
                  locations={this.state.filteredLocations}
                  lat={this.state.lat}
                  lng={this.state.lng}
                  zoom={this.state.zoom}
                  isResource={true}
                />
                <div className="results-section">
                  {/* 横屏和电脑版显示顶部Filter Bar */}
                  {!isMobilePortrait && this.renderFilterBar({ showPrintButton: true })}
                  <ResourceCard
                    callbackFromParent={this.myCallback}
                    locations={this.state.filteredLocations}
                    isResource={true}
                  />
                </div>
              </div>
            ) : map ? (
              <ResourceMap
                key={`map-${this.state.lat}-${this.state.lng}-${this.state.zoom}`}
                closeFilter={this.closeNav}
                onFocus={this.state.showAlert}
                locations={this.state.filteredLocations}
                lat={this.state.lat}
                lng={this.state.lng}
                zoom={this.state.zoom}
                isResource={true}
                ref={(el) => (this.componentRef = el)}
              />
            ) : (
              <div className="single-view-container">
                {/* 横屏和电脑版显示顶部Filter Bar */}
                {!isMobilePortrait && this.renderFilterBar()}
                <ResourceCard
                  callbackFromParent={this.myCallback}
                  locations={this.state.filteredLocations}
                  isResource={true}
                  ref={(el) => (this.componentRef = el)}
                />
              </div>
            )}

            {/* 移动竖屏版显示底部可折叠Filter Bar */}
            {isMobilePortrait && renderMobileBottomFilter()}
          </div>
        )}
      </div>
    );
  }
    }
    
    export default translate(FilterForm);
